import { useState } from 'react';
import {
  Button,
  AppBar,
  Toolbar,
  Box,
  Stack,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { FaqModal } from '../faq/FaqModal';
import logoModule from '@chr/autoStyle/dist/img/CHR/CHR_LogoTM_Horz_2C_RGB.png';
import HelpOutline from '@mui/icons-material/HelpOutline';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { useHistory  } from 'react-router-dom';
import { useAdobeActions } from '../../hooks/useAnalyticsUIEvents';

export interface HeaderProps {
  config: AppConfig;
}

export const Header = ({ config }: HeaderProps) => {
  const translate = useTranslation();
  const { breakpoints } = useTheme();
  const isMobileScreen = useMediaQuery(breakpoints.down('md'));
  const [showFaqModal, setShowFaqModal] = useState(false);
  const history = useHistory();
  const { handleAdobeAction } = useAdobeActions();
  const theme = useTheme();

  const handleLoginClick = () => {  
    handleAdobeAction('button','click','Login');
    window.location.href = `${config.baseUrl}/search/`;
  }

  const handleHelpClick = () => {
    handleAdobeAction('button', 'click', 'Need Help(search)');
    setShowFaqModal(true);
  };

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: 'white' }}>
        <Toolbar disableGutters>
          <Stack
            alignItems="center"
            data-testid="header-toolbar-stack"
            direction="row"
            justifyContent="space-between"
            sx={{
              paddingLeft: isMobileScreen ? 2 : 6,
              paddingRight: isMobileScreen ? 2 : 6,
              width: '100%',
              height: '72px',
            }}
          >
            <a href="#">
              <img
                data-testid="header-toolbar-stack-chr-logo"
                src={logoModule}
                alt="CHR-logo"
                height="40px"
                width="174px"
                onClick={() => history.push('/')}
              />
            </a>
            <Stack direction="row" spacing={isMobileScreen ? .5 : 1} alignItems="center" sx={{ ml: isMobileScreen ? 'auto' : undefined }}>
              <Button
                data-testid="header-toolbar-login"
                className="header-button"
                sx={{
                  fontSize: 14,
                  fontWeight: 600,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: isMobileScreen ? 40 : 80,
                  color: theme.palette.grey[900],
                  gap: .5,
                }}
                onClick={handleLoginClick}>
                <LockOutlined className="header-icon" sx={isMobileScreen ? { width: 24, height: 24 } : undefined} />
                {!isMobileScreen && translate('Login')}
              </Button>
              <Button
                data-testid="header-toolbar-help"
                className="header-button"
                sx={{
                  fontSize: 14,
                  fontWeight: 600,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: isMobileScreen ? 40 : 80,
                  color: theme.palette.grey[900],
                  gap: .5,
                }}
                onClick={handleHelpClick}>
                <HelpOutline className="header-icon" sx={isMobileScreen ? { width: 24, height: 24 } : undefined} />
                {!isMobileScreen && translate('Help')}
              </Button>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
        <FaqModal
          open={showFaqModal}
          handleClose={() => {
            setShowFaqModal(false);
          }}
        />
    </Box>
  );
};
